
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseCurrencyAmount from '@/components/BaseCurrencyAmount.vue';
import { SalesQuote } from '@/api';

@Component({
  components: { BaseCurrencyAmount },
})
export default class NewClaimOverviewProducts extends Vue {
  @Prop({ type: Object, default: () => undefined })
  claimAgreement!: SalesQuote;

  @Prop({ type: Object, default: () => undefined })
  claimTotals!: any;

  get agreement(): SalesQuote {
    return this.claimAgreement || this.$store.getters['claim/agreement'];
  }

  get totals(): any {
    return (
      this.claimTotals || this.$store.getters['claim/calculateClaimTotals']
    );
  }
}
